<template>
  <div id="Rahmen" v-on:click="$emit('clicked')">
    <router-link :to="link">
      {{title}}
    </router-link>
    <DropdownMo v-for="item in items" :key="item.title" :title="item.title" :link="item.link" style="font-size: 0.7em; border: 0;" />
  </div>
</template>

<script>
  import DropdownMo from '@/components/DropdownMo'

  export default {
    name: 'DropdownMo',
    props: {
      title: {default: null},
      items: {default: null},
      link: {type: String, default: ''}
    },

    data () {
      return {
        isOpen: false
      }
    },

    components: {
      DropdownMo
    },

    methods: {

    },

    computed: {

    },

    mounted: function () {

    }
  }
</script>

<style scoped>

  #Rahmen {
    margin-top: 0.2em;
    margin-bottom: 0;
    width: 100%;
    color: #6e171d;
    font-size: 1.8em;
    border-bottom: 2px dotted #6e171d;
  }

  a {
    text-decoration: none;
  }

</style>



// WEBPACK FOOTER //
// src/components/DropdownMo.vue